import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'treeSearch'
})
export class TreeSearchPipe implements PipeTransform {

  transform(tree: any, id: any): boolean {
    return this.searchElementInTree(tree, id);
  }

  private searchElementInTree(tree: any[], id: any): boolean {
    if (!tree || tree.length === 0) {
      return false;
    }

    if (tree.some(node => node.id === id)) {
      return true;
    }

    for (let node of tree) {
      if (node.Children && node.Children.length > 0) {
        if (this.searchElementInTree(node.Children, id)) {
          return true;
        }
      }
    }

    return false;
  }
}
